/*eslint-disable*/
import React, { useRef, useState } from 'react';
import { addNewPropertyOffer, checkPropertyOfferRates, updatePropertyOffer } from '../../../store/actions';
import { useSelector } from 'react-redux';
import { Box, Button, CircularProgress, Divider, FormControlLabel, IconButton, InputAdornment, MenuItem, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { CssTextField } from '../../../components/TextField';
import { Add, ArrowBack, CalendarMonth, Cancel } from '@mui/icons-material';
import moment from 'moment';
import RatesPreviewModal from './RatesPreviewModal';

const startIcon = {
    startAdornment: (
        <InputAdornment position="start">
            <CalendarMonth fontSize='small' sx={{ cursor: "pointer" }} />
        </InputAdornment>
    ),
}

function AddNewRate({ dispatch, colors, setIsAdding, updatingData }) {
    const types = [
        { name: "Occupancy based", value: "occupancy_based", visible: true },
    ]
    const initialValues = {
        startDate: updatingData?.start_date ? moment.unix(updatingData?.start_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        endDate: updatingData?.end_date ? moment.unix(updatingData?.end_date).format("YYYY-MM-DD") : moment().add(1, "days").format("YYYY-MM-DD"),
        type: updatingData?.type ?? "occupancy_based",
    }
    const initialPerc = {
        percentage: 99,
        standard_rate: 0,
        child_rate: 0,
        single_occupancy_rate: 0,
        max_occupancy_rate: 0,
        extra_bed_rate: 0,
        plus_percentage: "",
        minus_percentage: "",
        plusOrMinus: "minus",
    }
    const updatingPercArray = updatingData?.percentages?.map(e => ({...e, plusOrMinus: e.plus_percentage > 0 ? "plus" : "minus"}))
    const startInputRef = useRef();
    const endInputRef = useRef();
    const [values, setValues] = useState(initialValues);
    const [percentages, setPercentages] = useState(updatingData?.percentages?.length ? updatingPercArray : [initialPerc]);
    const [temp, setTemp] = useState("");
    const [rates, setRates] = useState([]);
    const [ratesModal, setRatesModal] = useState(false);
    const [selectedOfferContext, setSelectedOfferContext] = useState(null);

    const { isLoading } = useSelector(({ loading }) => ({
        isLoading: loading,
    }));

    const handleChange = (event) => {
        let fieldname = event?.target?.name;
        let data = values;
        data[fieldname] = event?.target?.value;
        setTemp(event.target.value);
        setValues(data);
    }

    const handleNewFieldBtn = () => {
        if(percentages[percentages.length - 1].percentage === 0){
            return
        }
        var joined = percentages.concat({ ...initialPerc, percentage: percentages[percentages.length - 1].percentage - 1 });
        setPercentages(joined)
    }

    const removeField = (index) => {
        if (percentages?.length > 1) {
            var arr = percentages;
            var filtered = arr.filter((e, i) => i !== index);
            setPercentages(filtered)
        }
    }

    const handleNewFieldValueChange = (i, event) => {
        var valueAdd = percentages;
        const field = event.target.name;
        if (event?.target) {
            valueAdd[i][field] = event.target.value;
        } else {
            valueAdd[i][field] = event
        }

        if(event.target.name === "plus_percentage"){
            valueAdd[i].minus_percentage = 0;
        }else if (event.target.name === "minus_percentage"){
            valueAdd[i].plus_percentage = 0;
        }
        setTemp(event.target.value);
        setPercentages(valueAdd)
    }

    const handlePlusOrMinusChange = (i, val) => {
        var valueAdd = percentages;
        const field = "plusOrMinus";
        valueAdd[i][field] = val;

        if(val === "plus"){
            valueAdd[i].minus_percentage = 0;
        }else if (val === "minus"){
            valueAdd[i].plus_percentage = 0;
        }
        setTemp(val);
        setPercentages(valueAdd)
    }
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        let formattedPercentages = percentages.map(({plusOrMinus, ...rest}) => ({
            percentage: parseFloat(rest.percentage) || 0,
            plus_percentage: plusOrMinus === "plus" ? parseFloat(rest.plus_percentage) || 0 : 0,
            minus_percentage: plusOrMinus === "minus" ? parseFloat(rest.minus_percentage) || 0 : 0,
            standard_rate: 0,
            child_rate: 0,
            single_occupancy_rate: 0,
            max_occupancy_rate: 0,
            extra_bed_rate: 0,
        }));
        let data = {
            startDate: moment(values.startDate, "YYYY-MM-DD").unix(),
            endDate: moment(values.endDate, "YYYY-MM-DD").unix(),
            type: "occupancy_based",
            percentages: formattedPercentages,
        }
        if(updatingData){
            data.id = updatingData?._id;
        }
        await dispatch(updatingData ? updatePropertyOffer(data) : addNewPropertyOffer(data));
        setValues(initialValues);
        setIsAdding(false);
    }

    const handleCheckRatesButton = async (val, idx) => {
        if (!val.plus_percentage && !val.minus_percentage) {
            return;
        }
        let data = {
            startDate: moment(values.startDate, "YYYY-MM-DD").unix(),
            endDate: moment(values.endDate, "YYYY-MM-DD").unix(),
            plusPercentage: parseFloat(val.plus_percentage) || 0,
            minusPercentage: parseFloat(val.minus_percentage) || 0,
        };
        setSelectedOfferContext({
            startDate: moment(values.startDate, "YYYY-MM-DD").unix(),
            endDate: moment(values.endDate, "YYYY-MM-DD").unix(),
            percentage: val.percentage,
            prevPercentage: idx === 0 ? 100 : percentages[idx - 1]?.percentage,
            plusPercentage: parseFloat(val.plus_percentage) || 0,
            minusPercentage: parseFloat(val.minus_percentage) || 0,
            plusOrMinus: val.plusOrMinus,
        });
        let ratesRes = await dispatch(checkPropertyOfferRates(data));
        if (ratesRes) {
            setRates(ratesRes);
            setRatesModal(true);
        }
    };

    return (
        <Box>
            <Stack
                direction={"row"}
                alignItems={"end"}
                spacing={1}
                mb={3}
            >
                <Button size='small' variant='outlined' onClick={() => {
                    setIsAdding(false)
                }}>
                    <ArrowBack fontSize='small' />
                </Button>
                <Typography color={colors.grey[100]} fontWeight="bold" variant='h4'>
                    {updatingData ? "UPDATE" : "ADD NEW"} RATE
                </Typography>
            </Stack>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <Stack direction="row" spacing={1}>
                        <CssTextField
                            fullWidth
                            required
                            size="small"
                            type="date"
                            label="start date"
                            placeholder="Start date"
                            name="startDate"
                            value={moment(values.startDate).format("YYYY-MM-DD")}
                            inputProps={{ min: moment().format("YYYY-MM-DD"), max: moment().add(720, "days").format("YYYY-MM-DD") }}
                            onChange={handleChange}
                            inputRef={startInputRef}
                            onClick={() => startInputRef.current.showPicker()}
                            InputProps={startIcon}
                        />
                        <CssTextField
                            fullWidth
                            required
                            size="small"
                            type="date"
                            label="End date"
                            placeholder="End date"
                            name="endDate"
                            value={moment(values.endDate).format("YYYY-MM-DD")}
                            inputProps={{ min: moment(values.startDate).format("YYYY-MM-DD"), max: moment().add(720, "days").format("YYYY-MM-DD") }}
                            onChange={handleChange}
                            inputRef={endInputRef}
                            onClick={() => endInputRef.current.showPicker()}
                            InputProps={startIcon}
                        />
                    </Stack>
                    <CssTextField
                        fullWidth
                        select
                        size="small"
                        label="Rate type"
                        name="type"
                        value={values.type}
                        disabled
                        // onChange={handleChange}
                    >
                        {types?.map((type) => (
                            <MenuItem value={type.value} key={type.value} style={{ display: type.visible ? "" : "none" }}>
                                {type.name}
                            </MenuItem>
                        ))}
                    </CssTextField>
                    <Divider />
                    <>
                        {percentages?.map((el, idx) => (
                            <Stack
                                key={idx}
                                p={2}
                                spacing={2}
                                borderRadius={2}
                                bgcolor={colors.primary[400]}
                            >
                                <Stack alignItems="end" m={-1}>
                                    <IconButton size='small' onClick={() => removeField(idx)}>
                                        <Cancel />
                                    </IconButton>
                                </Stack>
                                <CssTextField
                                    fullWidth
                                    required
                                    size="small"
                                    type="number"
                                    label="Percentage"
                                    placeholder="Percentage"
                                    name="percentage"
                                    value={el?.percentage ?? ""}
                                    onChange={(newValue) => handleNewFieldValueChange(idx, newValue)}
                                    inputProps={{ min: 0, max: idx === 0 ? 99 : percentages[idx - 1].percentage - 1 }}
                                    helperText={`if ${el.percentage}% - ${idx === 0 ? "100" : percentages[idx - 1].percentage}% room is available, rate will ${el.plusOrMinus === "plus" ? "increase" : "decrease"}`}
                                />
                                <Stack direction="row" alignItems="center" spacing={1}>
                                <Typography>
                                    Current rate
                                </Typography>
                                <RadioGroup
                                    row
                                    name="plusOrMinus"
                                    value={el?.plusOrMinus}
                                    onChange={() => handlePlusOrMinusChange(idx, el.plusOrMinus === "plus" ? "minus" : "plus")}
                                >
                                    <FormControlLabel value="plus" control={<Radio />} label="Plus" />
                                    <FormControlLabel value="minus" control={<Radio />} label="Minus" />
                                </RadioGroup>
                                </Stack>
                                <CssTextField
                                    fullWidth
                                    required
                                    size="small"
                                    type="number"
                                    label={"Percentage"}
                                    placeholder={"Percentage"}
                                    name={el?.plusOrMinus === "plus" ? "plus_percentage" : "minus_percentage"}
                                    value={el?.plusOrMinus === "plus" ? el?.plus_percentage : el?.minus_percentage}
                                    onChange={(newValue) => handleNewFieldValueChange(idx, newValue)}
                                    inputProps={{ min: 1, max: 100 }}
                                />
                                <Stack alignItems="start">
                                    <Button
                                        size='small'
                                        variant='contained'
                                        onClick={() => handleCheckRatesButton(el, idx)}
                                        disabled={!el.plus_percentage && !el.minus_percentage}
                                    >
                                        Check rates
                                    </Button>
                                </Stack>
                            </Stack>
                        ))}
                        <Button fullWidth size='small' onClick={handleNewFieldBtn} disabled={percentages[percentages.length - 1].percentage === 0}>
                            <Add /> <b>Add new percentage</b>
                        </Button>
                    </>
                    <Stack direction="row" justifyContent="space-between" spacing={2}>
                        <Button variant="outlined" onClick={() => setIsAdding(false)}>
                            <b>Cancel</b>
                        </Button>
                        <Button type="submit" variant="contained">
                            {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Submit</b>}
                        </Button>
                    </Stack>
                </Stack>
            </form>

            <RatesPreviewModal
                open={ratesModal}
                onClose={() => setRatesModal(false)}
                ratesData={rates}
                offerContext={selectedOfferContext}
            />
        </Box>
    )
}

export default AddNewRate;
